module.exports = __webpack_public_path__ + "static/media/02-01.1455998b.png";